import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight, faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
const ToggleButton = ({ showDaily, setShowDaily }) => {
    return (
        <TouchableOpacity
            onPress={() => setShowDaily(!showDaily)}
            style={[
                styles.toggleButton,
                {
                    backgroundColor: 'white', // Button color
               
                    paddingTop:2,
               
                    alignItems: 'center',
                    justifyContent: 'center',
                 
                },
            ]}
        >
            <FontAwesomeIcon 
                icon={showDaily ? faChevronCircleRight : faChevronCircleLeft} 
                size={18} 
                color="black" 
            />
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    toggleButton: {
        height: 40, // Optional: Adjust button height
        width: 40, // Optional: Adjust button width
    },
});

export default ToggleButton;
